import { render, staticRenderFns } from "./TradersFeesAndRates.vue?vue&type=template&id=f8be9bba&"
import script from "./TradersFeesAndRates.vue?vue&type=script&lang=js&"
export * from "./TradersFeesAndRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports